import * as React from "react";
import { forwardRef } from "react";
const CashPaymentBillIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 51 50",
  "data-category": "sources",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  clipPath: "url(#cash-payment-bill-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#1274C4",
  d: "M1.20044 29.6875v18.75m.86206-3.125h34.375c0-1.6576-.6585-3.2473-1.8306-4.4194s-2.7618-1.8306-4.4194-1.8306H22.375c0-1.6576-.6585-3.2473-1.8306-4.4194s-2.7618-1.8306-4.4194-1.8306H2.0625m12.5 6.25h7.8125"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#114A7B",
  d: "M16.9062 6.25c.1546 0 .3056.04582.4341.13166.1285.08585.2286.20786.2877.35062.0592.14275.0746.29984.0445.45138-.0302.15155-.1046.29076-.2138.40002-.1093.10926-.2485.18366-.4.21381-.1516.03014-.3087.01467-.4514-.04446-.1428-.05913-.2648-.15926-.3506-.28774-.0859-.12848-.1317-.27952-.1317-.43404 0-.2072.0823-.40591.2288-.55243.1465-.14651.3452-.22882.5524-.22882m26.5625 12.5c.1546 0 .3056.0458.4341.1317.1285.0858.2286.2078.2877.3506.0592.1427.0746.2998.0445.4514-.0302.1515-.1046.2907-.2138.4-.1093.1092-.2485.1836-.4.2138-.1516.0301-.3087.0147-.4514-.0445-.1428-.0591-.2648-.1592-.3506-.2877-.0859-.1285-.1317-.2795-.1317-.4341 0-.2072.0823-.4059.2288-.5524s.3452-.2288.5524-.2288"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1274C4",
  d: "M14.3229 1.5625h31.7292c.7703.00825 1.5061.32089 2.0466.86968.5406.54879.8422 1.28916.8388 2.05949V22.0708c.0034.7704-.2982 1.5107-.8388 2.0595-.5405.5488-1.2763.8615-2.0466.8697H14.3229c-.7702-.0082-1.506-.3209-2.0466-.8697s-.8421-1.2891-.8388-2.0595V4.49167c-.0033-.77033.2982-1.5107.8388-2.05949s1.2764-.86143 2.0466-.86968"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#114A7B",
  d: "M30.1875 17.1875c2.5888 0 4.6875-2.0987 4.6875-4.6875 0-2.58883-2.0987-4.6875-4.6875-4.6875S25.5 9.91117 25.5 12.5c0 2.5888 2.0987 4.6875 4.6875 4.6875"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cash-payment-bill-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h50v50H.5z"
}))));
const ForwardRef = forwardRef(CashPaymentBillIcon);
ForwardRef.category = "sources";
export default ForwardRef;
export { ForwardRef as CashPaymentBillIcon };